/**
 * Utilidad para calcular la longitud total de una ruta de cable
 * usando la fórmula de Haversine entre cada par de puntos consecutivos.
 * @module utils/calcularLongitudRuta
 */

type PuntoLatLng = { lat: number; lng: number }

const RADIO_TIERRA_METROS = 6371000

function distanciaHaversine(a: PuntoLatLng, b: PuntoLatLng): number {
  const φ1 = (a.lat * Math.PI) / 180
  const φ2 = (b.lat * Math.PI) / 180
  const Δφ = ((b.lat - a.lat) * Math.PI) / 180
  const Δλ = ((b.lng - a.lng) * Math.PI) / 180

  const h =
    Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
    Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2)
  const c = 2 * Math.atan2(Math.sqrt(h), Math.sqrt(1 - h))
  return RADIO_TIERRA_METROS * c
}

export function calcularLongitudRuta(ruta: PuntoLatLng[]): number {
  if (!ruta || ruta.length < 2) return 0
  let total = 0
  for (let i = 0; i < ruta.length - 1; i++) {
    total += distanciaHaversine(ruta[i], ruta[i + 1])
  }
  return total
}
